import { render, staticRenderFns } from "./PointGpayComplete.vue?vue&type=template&id=4ee9150a"
import script from "./PointGpayComplete.vue?vue&type=script&lang=js"
export * from "./PointGpayComplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports